import React from 'react';

const SvgReddit = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <path
      d="M8.5 0C4.08 0 .5 3.58.5 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8Zm4.67 9.17c.02.14.03.28.03.43 0 2.19-2.55 3.97-5.7 3.97s-5.7-1.78-5.7-3.97c0-.15.01-.29.03-.43a1.28 1.28 0 0 1 .47-2.47c.35 0 .66.14.89.36.88-.63 2.09-1.04 3.44-1.09l.58-2.73c.02-.08.06-.15.13-.2.06-.05.14-.06.22-.05l1.93.41a.92.92 0 1 1-.1.45l-1.73-.36-.52 2.44c1.33.06 2.53.47 3.39 1.09.24-.23.55-.36.89-.36.71 0 1.28.57 1.28 1.28 0 .49-.28.92-.69 1.14l-.01.01Zm-6.67.92c0 .46.37.83.83.83s.83-.37.83-.83c0-.46-.37-.83-.83-.83s-.83.37-.83.83Zm4.73 1.61c-.54.54-1.41.81-2.73.81s-2.19-.27-2.73-.81a.3.3 0 0 1 0-.43.3.3 0 0 1 .43 0c.41.41 1.14.61 2.3.61s1.89-.2 2.3-.61a.3.3 0 0 1 .43 0 .3.3 0 0 1 0 .43Zm-.2-1.61c0 .46.37.83.83.83s.83-.37.83-.83c0-.46-.37-.83-.83-.83s-.83.37-.83.83Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgReddit;
